import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const q = (lang) => (lang && lang !== "en" ? `?lang=${lang}` : "");

export const api = {
  // Config
  getConfig: (lang) => axios.get(`${API}/config${q(lang)}`).then(res => res.data),

  // Seed data
  getSeedData: (lang) => axios.get(`${API}/seed-data${q(lang)}`).then(res => res.data),

  // Users
  createOrGetUser: (data) => axios.post(`${API}/users`, data).then(res => res.data),
  getUser: (userId) => axios.get(`${API}/users/${userId}`).then(res => res.data),

  // Assessments
  createAssessment: (data) => axios.post(`${API}/assessments`, data).then(res => res.data),
  getAssessment: (assessmentId, lang) => axios.get(`${API}/assessments/${assessmentId}${q(lang)}`).then(res => res.data),
  getUserAssessments: (userId) => axios.get(`${API}/assessments/user/${userId}`).then(res => res.data),
  compareAssessments: (id1, id2, lang) => axios.get(`${API}/assessments/compare/${id1}/${id2}${q(lang)}`).then(res => res.data),
};

// Local storage helpers
export const storage = {
  setUser: (user) => localStorage.setItem('speaking_wheel_user', JSON.stringify(user)),
  getUser: () => {
    const user = localStorage.getItem('speaking_wheel_user');
    return user ? JSON.parse(user) : null;
  },
  clearUser: () => localStorage.removeItem('speaking_wheel_user'),

  setAssessmentProgress: (progress) => localStorage.setItem('assessment_progress', JSON.stringify(progress)),
  getAssessmentProgress: () => {
    const progress = localStorage.getItem('assessment_progress');
    return progress ? JSON.parse(progress) : null;
  },
  clearAssessmentProgress: () => localStorage.removeItem('assessment_progress'),
};
